import {apiClient} from '@/services/base/BaseService';

export async function login(email: string, password: string) {
  return apiClient.post('/auth/login', {
    email,
    password,
  });
}

export async function getCookie() {
  return apiClient.get('/csrf-cookie');
}
